import PropTypes from 'prop-types'
import React from 'react'

import { ClanTag } from 'react-wot-bootstrap'
import { POSTBATTLE_SCREEN_SUBTITLE_BATTLE_DIRECTION } from './constants.jsx'
import { DIRECTIONS } from 'constants'

import styles from './Subtitle.scss'

const Subtitle = (props) => {
    return (
        <div className={styles.base}>
            {POSTBATTLE_SCREEN_SUBTITLE_BATTLE_DIRECTION(props.direction)}
            <span className={styles.clan}>
                <ClanTag {...props.clan} />
            </span>
        </div>
    )
}

Subtitle.propTypes = {
    clan: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        tag: PropTypes.string.isRequired,
        color: PropTypes.string,
        emblem: PropTypes.string.isRequired,
    }).isRequired,
    direction: PropTypes.oneOf(DIRECTIONS).isRequired,
}

export default Subtitle



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/Subtitle/Subtitle.jsx